import axios from 'axios'

const textClient = axios.create({
  baseURL: '/static/user_text.json'
})

export default textClient
